import { TbArrowBackUp } from "react-icons/tb";
import { useShallow } from "zustand/react/shallow";
import { useFDAChangeManagementFlow } from "../../../hooks/useFDAChangeManagementFlow";
import { useFDAChangeManagementStore } from "../../../store/useFDAChangeManagementStore";

const Question = () => {
  const selectedQuestion = useFDAChangeManagementStore(
    useShallow((state) => state.selectedQuestion),
  );

  const [answerQuestion, undoAnswerQuestion] = useFDAChangeManagementFlow();

  return (
    <div className="flex h-full flex-col items-center justify-end">
      <button
        className="btn absolute top-0 left-0 mt-3 ml-4 border-none bg-gray-400 hover:border-none"
        onClick={() => undoAnswerQuestion()}
      >
        <TbArrowBackUp />
        Previous question
      </button>
      <span className="block p-4 text-center text-lg">
        {selectedQuestion.question}
      </span>
      <div className="flex w-full items-center justify-center">
        {!selectedQuestion.lastState && (
          <>
            <button
              className="btn btn-neutral hover:bg-success mx-3 w-auto rounded bg-gray-200 py-1 text-gray-800 md:w-40 lg:w-32"
              disabled={selectedQuestion.onlyNegative}
              onClick={() =>
                answerQuestion({ question: selectedQuestion, answer: "yes" })
              }
            >
              Yes
            </button>
            <button
              className="btn btn-neutral mx-3 w-auto rounded bg-gray-200 py-1 text-gray-800 hover:bg-red-400 md:w-40 lg:w-32"
              onClick={() =>
                answerQuestion({ question: selectedQuestion, answer: "no" })
              }
            >
              No
            </button>
          </>
        )}
        {selectedQuestion.lastState && (
          <button
            className="btn btn-neutral btn-wide mx-3 rounded bg-gray-200 py-1 text-gray-800 hover:bg-gray-100"
            onClick={() =>
              answerQuestion({ question: selectedQuestion, answer: "finish" })
            }
          >
            Finish
          </button>
        )}
      </div>
    </div>
  );
};
export default Question;
